const idb = window.idb = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB; 
// const idbTransact = window.idbt = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction;
// const idbKeyRange = window.idbkr = window.IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;

if (!idb) {
  console.log("Your browser doesn't support a stable version of IndexedDB.");
}

let db;
let request = idb.open("recentBillItems", 1);

request.onerror = (e)=>{
  console.log("error: ", e);
};

request.onsuccess = (e)=>{
  db = request.result;
  console.log("success ", db, e);
};

request.onupgradeneeded = (e)=>{
  let database = e.target.result;
  let objectStore = database.createObjectStore("recentBillItems", {keyPath: "id"});
  console.log("[onupgradeneeded] objectStore Ref: ", objectStore);
  console.log(e);
};

export function addRecentlyUsedBillItem(item){
  let request = db.transaction(["recentBillItems"], "readwrite");
  item.fecha = Date.now();
  request.objectStore("recentBillItems").add(item);

  request.onsuccess = (e)=>{
    console.log(e);
    console.log("[SUCCESS] Recently Used BillItem added: ", e);
  };

  request.onerror = (e)=>{
    console.log(e);
    console.log("[ERROR] Recently Used BillItem added: ", e.target.error);
  };
}

export function getRecentlyUsedBillItems(){
  let objectStore;
  let cursor;
  if(db && db.transaction){
    objectStore =  db.transaction("recentBillItems").objectStore("recentBillItems");
    cursor = objectStore.openCursor();
  
  }
  const result = new Promise((resolve, reject)=>{
    const recentItems =[];
    if(cursor){
      cursor.onsuccess = (e)=>{
        let cursor = e.target.result;
        if (cursor) {
          recentItems.push(cursor.value);
          cursor.continue();
        }
        resolve(recentItems);
      };
      cursor.onerror = (e)=>{
        console.log("[ERROR] getRecentlyUsedBillItems: ", e.target.error);
        reject(e.target.error);
      };
    }else reject("unable to open cursor - cursor is undefined");

  });
  return result;
}
//TODO: write this function?
export function getRecentlyUsedBillItem(id){
  let result = null;
  if(db){
    let transaction = db.transaction(["recentBillItems"]);
    let objectStore = transaction.objectStore("recentBillItems");
    let request = objectStore.get(id);
    result = new Promise((resolve, reject)=>{
      request.onerror = (e)=>{
        console.log("[ERROR] getting recently Used BillItem", e);
        reject(e);
      };
    
      request.onsuccess = (e)=>{
        console.log(e);
        if(request.result){
          resolve(request.result);
        }
        else reject("Not found.");
      };
    });
  }

  
  return result;
}

export function updateRecentlyUsedBI(id){
  let objectStore = db.transaction(["recentBillItems"], "readwrite").objectStore("recentBillItems");
  let request = objectStore.get(id);
  let result = { success: false, error: false };

  request.onerror = (e)=>{
    console.log("Error updating item: ", e.target.error);
  };

  request.onsuccess = (e)=>{
    let item = e.target.result;
    item.fecha = Date.now();

    let requestUpdate = objectStore.put(item);
    requestUpdate.onerror = (e)=>{
      console.log("Error updating item: ", e.target.error);
      result.error = e.target.error;
    };

    requestUpdate.onsuccess = (e)=>{
      console.log(e);
      result.success = true;
    };
  };

  return result;
}

export function deleteRecentlyUsedByID(id){
  // open a database transaction and delete the task, finding it by the name we retrieved above
  let transaction = db.transaction(["recentBillItems"], "readwrite");
  let request = transaction.objectStore("recentBillItems").delete(id);

  request.onerror = (e)=>{
    console.log("Error deleting item: ", e.target.error);
  };
  request.onsuccess = (e)=>{
    console.log("[request.onsuccess| e] ",e);
  };
  // report that the data item has been deleted
  transaction.oncomplete = (e)=> {
    console.log("[transaction.oncomplete| e] ",e);
  };

}